import { render, staticRenderFns } from "./research-document-restrict-filter.vue?vue&type=template&id=29fb5fa6&"
import script from "./research-document-restrict-filter.vue?vue&type=script&lang=js&"
export * from "./research-document-restrict-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports